var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-product-card"},[_c('k-icon',{staticClass:"k-product-icon",attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5e3b31","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KaledoComponents/KProductCard.vue
// module id = 2072
// module chunks = 1612